import React from 'react';
import { ContentBlock, Grid, Grid2, GridItem } from '@riac/design-system';
import { usePrefetchSuspense } from 'src/lib/usePrefetch';
import { useFetch } from 'src/lib/FetchContext';
import { FaqItems } from 'src/pages/FAQPage/components/FaqItems/FaqItems';
import { GenericPageHeader } from 'src/components/GenericPageHeader';

const FAQ = (): JSX.Element => {
  const { fetch } = useFetch();
  // Get data on server-side
  const data = usePrefetchSuspense('faq-data', async () => {
    const req = await fetch('/api/faq/get');
    const { faqItems } = await req.json();
    return faqItems;
  }).read();

  // Create dynamic Schema.org markup based on content
  const schema = data ? data.slice().map((faq) => (`{
    "@type": "Question",
    "name": "${faq.FaqItem}",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": ${
    JSON.stringify(faq.FAQText
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/&(nbsp|amp|quot|lt|gt);/g, '')
      .replace(/\[\w+([^\]]*)\]([\s\S]*?)\[\/\w+\]/, '$2')
    )}
    }
  }`)) : [];

  let isLoading = false;
  if(data) {
    isLoading = false;
  } else {
    isLoading = true;
  }

  return (<>
    <GenericPageHeader
      title='Frequently Asked Questions'
      description={`At Rock Island Auction, we're committed to making your buying and selling experience seamless. Browse our comprehensive FAQ section to find quick answers to common questions and get the most from your auction experience.`}
    />
    <Grid2 className='py-20'>
      <FaqItems data={data || []} isLoading={isLoading} />
    </Grid2>
  </>);
};

export default FAQ;
